// Approvazione manuale delle nuove attività (backend/approval.py).
// Il backend è l'unica autorità: qui si decide solo COSA MOSTRARE. Solo uno stato ESPLICITO
// diverso da "approved" mostra il gate; un valore mancante (vecchio backend, account storico)
// non blocca mai nessuno — stessa regola di `email_verified === false` in ProtectedRoute.
export const APPROVAL_EVENT = "aiposto:approval-required";

export function approvalGateStatus(user, approval) {
  if (!user || user.role === "super_admin") return null;
  const status = approval && approval.status;
  if (status === "pending_approval" || status === "rejected" || status === "suspended") return status;
  return null;
}

export const GATE_COPY = {
  pending_approval: {
    title: "Registrazione completata",
    lines: [
      "Il tuo indirizzo email è stato verificato correttamente.",
      "La tua richiesta di attivazione di AiPosto è attualmente in fase di approvazione.",
      "Riceverai una comunicazione via email non appena il tuo account sarà abilitato.",
    ],
  },
  rejected: {
    title: "Richiesta non accolta",
    lines: [
      "Non è stato possibile accogliere la tua richiesta di attivazione di AiPosto.",
      "Se pensi si tratti di un errore, scrivici dall'indirizzo con cui ti sei registrato.",
    ],
  },
  suspended: {
    title: "Account temporaneamente sospeso",
    lines: [
      "Il tuo account AiPosto è temporaneamente sospeso: l'assistente e le nuove prenotazioni sono disattivati.",
      "I tuoi dati sono conservati. Per informazioni contattaci dall'indirizzo con cui ti sei registrato.",
    ],
  },
};

// Azioni del Super Admin per stato corrente (specchio di ACTIONS nel backend; la verifica vera è lato server).
export const ADMIN_ACTIONS = {
  pending_approval: ["approve", "reject"],
  approved: ["suspend"],
  rejected: ["approve"],
  suspended: ["reactivate"],
};

export const ACTION_COPY = {
  approve: { label: "Approva", confirm: "Approvare questa attività? Potrà usare AiPosto e riceverà un'email." },
  reject: { label: "Rifiuta", confirm: "Rifiutare questa richiesta? Il titolare riceverà un'email. Potrai approvarla in seguito." },
  suspend: { label: "Sospendi", confirm: "Sospendere l'attività? Assistente AI, nuove prenotazioni, promemoria e Google Calendar si fermano; i dati restano conservati." },
  reactivate: { label: "Riattiva", confirm: "Riattivare l'attività? Riprende solo il lavoro futuro: i messaggi ricevuti durante la sospensione non vengono elaborati." },
};

export const STATUS_LABEL = {
  pending_approval: "In attesa", approved: "Approvata", rejected: "Rifiutata", suspended: "Sospesa",
};
